import {
  createFieldValue,
  createStandardizedFieldValue,
  getNextUuid,
  batchCreateIntermediarySuperForField,
} from '@fs/zion-sls'
import { EVENT_FIELD_TYPES } from './eventTypes'
import { removeFieldOrEvent as sharedRemoveFieldOrEvent } from './elementUtils'

export const getFieldIdAndValue = ({ el, value, attribution }) => {
  let field
  if (el.elementType === 'FIELD') field = el
  else field = el?.subElements?.length ? el?.subElements?.[0] : el

  let fieldValue = createFieldValue(typeof value === 'string' ? value : value.originalText, attribution)
  if (value.standard) {
    fieldValue = createStandardizedFieldValue(value, field.fieldType, attribution)
  }
  if (field.fieldType === 'SEX_CODE') {
    fieldValue = createFieldValue(value.primaryText, attribution, `http://gedcomx.org/${value.key}`)
  }
  return { id: field.id, value: fieldValue }
}

export const getOrCreateSuperIdFromFormState = ({ field, newEvent, eventElements, selectedPerson }) => {
  let dispatches = []
  let intermediaryId
  const superType = field.superType
  const editedEventId = field.super

  if (!newEvent) {
    const editedEvent = eventElements.find((element) => element.id === editedEventId)
    const editedSuper =
      superType === 'EVENT' ? editedEvent : editedEvent?.subElements?.find((se) => se.elementType === superType)
    if (!editedSuper) {
      intermediaryId = getNextUuid()
      dispatches = [
        ...dispatches,
        ...batchCreateIntermediarySuperForField({
          partitionKey: selectedPerson?.partitionKey,
          intermediaryType: superType,
          intermediaryId,
          superId: editedEventId,
          superType: 'EVENT',
        }),
      ]
    } else {
      intermediaryId = editedSuper.id
    }
  } else if (superType === 'DATE') {
    intermediaryId = newEvent.dateId
  } else if (superType === 'PLACE') {
    intermediaryId = newEvent.placeId
  } else {
    intermediaryId = editedEventId
  }
  return { superId: intermediaryId, superType, dispatches }
}

export const removeFieldOrEvent = sharedRemoveFieldOrEvent

export const removeEventField = ({ field, form, fieldTypeKey, removedFieldsArray }) => {
  const {
    formState: { defaultValues },
    unregister,
    setValue,
  } = form
  const fieldType = EVENT_FIELD_TYPES[fieldTypeKey]

  const wasInitialField = !!defaultValues[fieldType]?.find((initialField) => initialField.id === field.id)
  if (wasInitialField) {
    removedFieldsArray.push({ ...field, superType: fieldTypeKey })
    setValue('removedFields', removedFieldsArray)
  }

  unregister(field.id)
}
